import { isRecord } from '@/utils/filter/isRecord';

export const isLocalFiltersRecord = (value: unknown): value is Record<string, Record<string, unknown>> => {
  if (!isRecord(value)) return false;
  return Object.values(value).every(isRecord);
};
